<template>
  <b-row>
    <b-col md="12">
      <b-card
        class="card-itens tableItensCompra compra-xml-table"
      >
        <div class="compra-xml-table-scroll compra-quantidades-scroll" role="region" aria-label="Quantidades dos itens da nota XML" tabindex="0">
        <table
          class="table table-head-custom table-head-bg table-vertical-center compra-quantidades-tabela"
        >
          <colgroup><col /><col /><col /><col /><col /><col /><col /><col /></colgroup>
          <thead>
            <tr>
              <th scope="col">Nº</th>
              <th class="text-left font-weight-bold text-muted pl-7">
                Itens Nota
              </th>
              <th class="text-right pr-0 font-weight-bold text-muted">
                Qtd Compra
              </th>
              <th class="text-center pr-0 font-weight-bold text-muted">UN</th>
              <th class="text-center pr-0 font-weight-bold text-muted">
                Operação
              </th>
              <th class="text-right pr-0 font-weight-bold text-muted">Fator</th>
              <th class="text-center pr-0 font-weight-bold text-muted">=</th>
              <th class="text-right pr-0 font-weight-bold text-muted pr-2">
                QTD ENTRADA
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, index) in items" :key="'item' + index">
              <td data-label="Nº">{{ parseFloat(index + 1) }}</td>
              <td
                class="pl-0 compra-item-descricao"
                data-label="Itens Nota"
              >
                <div class="compra-quantidade-descricao">
                  <span>{{ i.produto.descricao }}</span>
                  <b-button
                    v-b-tooltip.hover.right="'Editar produto'"
                    size="sm"
                    variant="outline-primary"
                    @click="editarItem(i, index)"
                  >
                    <i class="fas fa-edit" style="font-size: 10px"></i>
                  </b-button>
                </div>
              </td>
              <td class="text-right pr-0" data-label="Qtd Compra">
                {{ i.quantidade }}
              </td>
              <td class="text-right pr-0" data-label="UN">
                <VueSelect
                  ref="buscarUN"
                  label="nome"
                  append-to-body
                  :calculate-position="posicionarOpcoesUN"
                  :filterable="false"
                  :options="unidades_medidas"
                  @input="setConversao(i, index)"
                  @search="onSearchUN"
                  v-model="i.unidade_medida"
                  :class="{ hasErrors: unidadeError }"
                >
                  <template slot="no-options">
                    Informe a descrição da unidade de medida
                  </template>

                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.nome }}
                    </div>
                  </template>

                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.nome }}
                    </div>
                  </template>
                </VueSelect>
              </td>
              <td class="text-center pr-0" data-label="Operação">
                <b-button
                  size="sm"
                  variant="outline-primary"
                  class="w-100"
                  @click="alternarOperacaoConversao(i)"
                >
                  {{ labelOperacaoConversao(i) }}
                </b-button>
              </td>
              <td class="text-right pr-0" data-label="Fator">
                <money
                  class="form-control text-right"
                  v-model="i.fator_conversao"
                  v-bind="quantityOptions"
                  @input="onInputFatorConversao(i)"
                  @blur="onBlurFatorConversao(i)"
                />
              </td>
              <td class="text-center pr-0" data-label="Conversão">=</td>
              <td class="text-right pr-0 pr-7" data-label="QTD ENTRADA">
                <money
                  class="form-control text-right"
                  v-model="i.quantidade_conversao"
                  v-bind="quantityOptions"
                  @blur="onBlurConversao(i)"
                />
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </b-card>
    </b-col>

    <b-modal
      v-if="itemSelecionado.produto"
      id="modal-editar-item"
      v-model="showModal"
      :title="itemSelecionado.produto.descricao"
      size="lg"
      hide-footer
    >
      <b-tabs v-model="abaAtiva">
        <b-tab title="Produto" active>
          <br />
          <b-col md="3">
            <b-form-group label="Quantidade">
              <money
                class="form-control"
                v-model="itemSelecionado.quantidade"
                v-bind="quantityOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Tipo do Produto"
              label-for="tipo-produto-compra"
            >
              <b-form-select
                id="tipo-produto-compra"
                v-model="tipoProdutoSelecionado"
              >
                <b-form-select-option :value="null">
                  {{
                    itemSelecionado.vinculoProduto
                      ? "Manter tipo atual"
                      : "Padrão do cadastro"
                  }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="tipo in tiposProduto"
                  :key="tipo.id"
                  :value="tipo.id"
                >
                  {{ tipo.descricao }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="origem" label="Origem" label-for="origem">
              <b-form-select v-model="itemSelecionado.id_origem" placeholder="">
                <b-form-select-option
                  v-for="origem in origens"
                  :key="origem.id + 'origem'"
                  :value="origem.id"
                >
                  {{ origem.descricao }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="CST">
              <VueSelect
                placeholder="Digite o código para pesquisar"
                label="codigo"
                @input="setCSTCSOSN"
                v-model="itemSelecionado.cst_csosn"
                :options="cstcsosns"
              >
                <template slot="no-options">
                  Informe o código para buscar
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.codigo + " - " + option.descricao }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.codigo }}
                  </div>
                </template>
              </VueSelect>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-icon
              icon="info-circle-fill"
              id="tooltip-info"
              variant="primary"
              class="mr-2"
            ></b-icon>
            <b-tooltip target="tooltip-info" placement="right">
              Se utilizar um CFOP de uso e consumo (1556, 2556), não irá
              movimentar estoque.
            </b-tooltip>
            <b-form-group label="CFOP" label-for="form.id_cfop">
              <VueSelect
                placeholder="Digite o código para pesquisar"
                ref="buscarCliente"
                :filterable="false"
                v-model="itemSelecionado.cfop_compra"
                @input="setCFOP"
                :options="cfops"
                @search="onSearchCFOP"
              >
                <template slot="no-options">
                  Informe o código do CFOP
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.codigo }} - {{ option.descricao }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.codigo }}
                  </div>
                </template>
              </VueSelect>
            </b-form-group>
          </b-col>
        </b-tab>

        <b-tab title="ICMS ST">
          <br />

          <b-form-group label="% ICMS ST">
            <money
              class="form-control"
              v-model="itemSelecionado.pICMSST"
              v-bind="priceOptions"
            />
          </b-form-group>
          <b-form-group label="Base ST">
            <money
              class="form-control"
              v-model="itemSelecionado.VBCST"
              v-bind="priceOptions"
            />
          </b-form-group>

          <b-form-group label="Valor ICMS ST">
            <money
              class="form-control"
              v-model="itemSelecionado.VICMSST"
              v-bind="priceOptions"
            />
          </b-form-group>
        </b-tab>

        <b-tab title="ICMS/IPI">
          <br />
          <b-form-group label="% ICMS">
            <money
              class="form-control"
              v-model="itemSelecionado.pICMS"
              v-bind="priceOptions"
            />
          </b-form-group>

          <b-form-group label="Valor ICMS">
            <money
              v-model="itemSelecionado.vICMS"
              v-bind="priceOptions"
              class="form-control"
            />
          </b-form-group>
          <b-form-group label="Valor Base ICMS">
            <money
              v-model="itemSelecionado.vBCICMS"
              v-bind="priceOptions"
              class="form-control"
            />
          </b-form-group>

          <b-form-group label="% IPI">
            <money
              class="form-control"
              v-model="itemSelecionado.pIPI"
              v-bind="priceOptions"
            />
          </b-form-group>
          <b-form-group label="Base IPI">
            <money
              class="form-control"
              v-model="itemSelecionado.vBCIpi"
              v-bind="priceOptions"
            />
          </b-form-group>
          <b-form-group label="Valor IPI">
            <money
              class="form-control"
              v-model="itemSelecionado.vIPI"
              v-bind="priceOptions"
            />
          </b-form-group>
          <b-form-group label="CST IPI">
            <VueSelect
              placeholder="Digite o código para pesquisar"
              label="codigo"
              @input="setCSTIPI"
              v-model="cstipi"
              :options="cstipis"
              @search="onSearchCSTIPI"
              :clearable="true"
            >
              <template slot="no-options">
                Informe o código do CST IPI
              </template>
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.codigo + " - " + option.descricao }}
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.codigo + " - " + option.descricao }}
                </div>
              </template>
            </VueSelect>
          </b-form-group>
        </b-tab>

        <b-tab title="PIS/COFINS">
          <br />
          <b-form-group label="% PIS">
            <money
              class="form-control"
              v-model="itemSelecionado.pPIS"
              v-bind="priceOptions"
            />
          </b-form-group>

          <b-form-group label="Valor PIS">
            <money
              class="form-control"
              v-model="itemSelecionado.vPIS"
              v-bind="priceOptions"
            />
          </b-form-group>
          <b-form-group label="Base PIS">
            <money
              class="form-control"
              v-model="itemSelecionado.vBCPis"
              v-bind="priceOptions"
            />
          </b-form-group>

          <b-form-group label="CST PIS">
            <VueSelect
              label="codigo"
              @input="setCSTPIS"
              v-model="itemSelecionado.cstpis"
              :options="cstspis"
              placeholder="Digite o código para pesquisar"
              :clearable="true"
            >
              <template slot="no-options">
                Informe o código do CST PIS
              </template>
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.codigo + " - " + option.descricao }}
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.codigo + " - " + option.descricao }}
                </div>
              </template>
            </VueSelect>
          </b-form-group>

          <b-form-group label="% COFINS">
            <money
              class="form-control"
              v-model="itemSelecionado.pCOFINS"
              v-bind="priceOptions"
            />
          </b-form-group>

          <b-form-group label="Valor COFINS">
            <money
              class="form-control"
              v-model="itemSelecionado.vCOFINS"
              v-bind="priceOptions"
            />
          </b-form-group>
          <b-form-group label="Base COFINS">
            <money
              class="form-control"
              v-model="itemSelecionado.vBCConfis"
              v-bind="priceOptions"
            />
          </b-form-group>
          <b-form-group label="CST COFINS" label-for="form.id_cstcofins">
            <VueSelect
              label="codigo"
              v-model="itemSelecionado.cstcofins"
              :options="cstscofins"
              placeholder="Digite o código para pesquisar"
              :clearable="true"
            >
              <template slot="no-options">
                Informe o código do CST Cofins
              </template>
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.codigo + " - " + option.descricao }}
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.codigo + " - " + option.descricao }}
                </div>
              </template>
            </VueSelect>
          </b-form-group>
        </b-tab>
      </b-tabs>

      <div class="d-flex justify-content-end mt-4">
        <b-button variant="secondary" @click="showModal = false"
          >Cancelar</b-button
        >
        <b-button variant="primary" class="ml-2" @click="salvarEdicaoItem"
          >Salvar</b-button
        >
      </div>
    </b-modal>
  </b-row>
</template>

<script>
import _ from "lodash";
import VueSelect from "vue-select";
import { createPopper } from "@popperjs/core";
import "vue-select/dist/vue-select.css";
import { SistemaMixin } from "@/modules/Application";
import { validationMixin } from "vuelidate";
import { store } from "../../storeCompra";
import { Money } from "v-money";
import { quantityOptions, priceOptions } from "@/modules/Application";

export default {
  name: "compra-quantidade-itens",
  components: {
    VueSelect,
    Money,
  },
  mixins: [SistemaMixin, validationMixin],
  data() {
    return {
      store,
      unidades_medidas: [],
      multiplicar: 1,
      divisao: 2,
      unidadeError: false,
      hasFilled: false,
      cfops: [],
      cfop_compra: null,
      showModal: false,
      itemSelecionado: {},
      itemIndexSelecionado: null,
      tipoProdutoSelecionado: null,
      tiposProduto: [],
      quantityOptions,
      cstcsosn: null,
      cstcsosns: [
        {
          codigo: "00",
          descricao: "Tributada Integralmente",
        },
        {
          codigo: "10",
          descricao:
            "Tributada e com cobrança do ICMS por substituição tributária",
        },
        {
          codigo: "20",
          descricao: "Com redução de base de cálculo",
        },
        {
          codigo: "30",
          descricao:
            "Isenta ou não tributada e com cobrança do ICMS por substituição tributária",
        },
        {
          codigo: "40",
          descricao: "Isenta",
        },
        {
          codigo: "41",
          descricao: "Não tributada",
        },
        {
          codigo: "50",
          descricao: "Suspensão",
        },
        {
          codigo: "51",
          descricao: "Diferimento",
        },
        {
          codigo: "60",
          descricao: "ICMS cobrado anteriormente por substituição tributária",
        },
        {
          codigo: "70",
          descricao:
            "Com redução de base de cálculo e cobrança do ICMS por substituição tributária",
        },
        {
          codigo: "90",
          descricao: "Outras",
        },
      ],
      origens: [
        {
          id: 0,
          descricao: "0 - Nacional, exceto as indicadas nos códigos 3 a 5",
        },
        {
          id: 1,
          descricao:
            "1 - Estrangeira - Importação direta, exceto a indicada no código 6",
        },
        {
          id: 2,
          descricao:
            "2 - Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7",
        },
        {
          id: 3,
          descricao:
            "3 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40%",
        },
        {
          id: 4,
          descricao:
            "4 - Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam o Decreto-Lei nº 288/1967.",
        },
        {
          id: 5,
          descricao:
            "5 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%",
        },
        {
          id: 6,
          descricao:
            "6 - Estrangeira - Importação direta, sem similar nacional, constante em lista de Resolução Camex e gás natural",
        },
        {
          id: 7,
          descricao:
            "7 - Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução Camex e gás natural",
        },
        {
          id: 8,
          descricao:
            "8 – Nacional: mercadoria ou bem com Conteúdo de Importação superior a 70%;",
        },
      ],
      priceOptions,
      abaAtiva: 0,
      cfop: null,
      cstipis: [],
      cstspis: [],
      cstscofins: [],
    };
  },
  props: {
    items: {},
  },
  methods: {
    posicionarOpcoesUN(dropdown, component, { width }) {
      dropdown.style.width = width;
      dropdown.classList.add("compra-un-dropdown");
      const popper = createPopper(component.$refs.toggle, dropdown, {
        placement: "bottom-start",
        strategy: "fixed",
        modifiers: [
          { name: "offset", options: { offset: [0, 2] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
        ],
      });
      const observer = typeof ResizeObserver === "undefined"
        ? null
        : new ResizeObserver(() => popper.update());
      if (observer) observer.observe(dropdown);
      return () => {
        if (observer) observer.disconnect();
        popper.destroy();
      };
    },

    setCSTPIS(cstpis) {
      this.itemSelecionado.cstpis = cstpis;
    },
    setCSTIPI(cstipi) {
      this.itemSelecionado.cstipi = cstipi;
    },
    onSearchCSTIPI(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCSTIPI(loading, search, this);
      }
    },
    searchCSTIPI: _.debounce(async (loading, search, vm) => {
      vm.cstipis = await vm.getCSTIPIByCodigo(search);
      loading(false);
    }, 350),
    async editarItem(item, index) {
      this.getCSTIPIByCodigo().then((data) => (this.cstipis = data));
      this.getCSTPISByCodigo().then((data) => (this.cstspis = data));
      this.getCSTCofinsByCodigo().then((data) => (this.cstscofins = data));
      this.itemSelecionado = { ...item };
      this.itemIndexSelecionado = index;
      const idTipo = item.id_tipo ?? item.vinculoProduto?.id_tipo;
      this.tipoProdutoSelecionado = idTipo == null ? null : Number(idTipo);
      this.showModal = true;
      if (!this.tiposProduto.length) {
        try {
          const { data } = await this.$http.post("/produtos/tipos");
          this.tiposProduto = data;
        } catch {
          this.$toast.error("Não foi possível carregar os tipos de produto.");
        }
      }
    },

    salvarEdicaoItem() {
      const tipoOriginal = this.itemSelecionado.vinculoProduto?.id_tipo ?? null;
      if (
        this.tipoProdutoSelecionado !== null &&
        Number(this.tipoProdutoSelecionado) !== Number(tipoOriginal)
      ) {
        this.itemSelecionado.id_tipo = this.tipoProdutoSelecionado;
      } else {
        delete this.itemSelecionado.id_tipo;
      }
      this.itemSelecionado.produto_editado = true;
      this.items.splice(this.itemIndexSelecionado, 1, {
        ...this.itemSelecionado,
      });
      this.showModal = false;
      this.$emit("onItemsChange", this.items);
    },
    setCFOP(i) {
      if (!i.cfop_compra) {
        i.cfop_compra = this.cfop_compra;
        return;
      }
    },
    setCSTCSOSN(cstcsosn) {
      this.itemSelecionado.cst_csosn = cstcsosn;
    },
    onSearchCFOP(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCFOP(loading, search, this);
      }
    },
    searchCFOP: _.debounce(async (loading, search, vm) => {
      vm.cfops = await vm.getCFOPByCodigo(search);
      loading(false);
    }, 350),
    onSearchUN(search, loading) {
      if (search.length) {
        loading(true);
        this.searchUN(loading, search, this);
      }
    },
    searchUN: _.debounce(async (loading, search, vm) => {
      vm.unidades_medidas = await vm.getUNByDescricao(search);
      loading(false);
    }, 350),
    toNumber(value, fallback = 0) {
      const number = Number(value);
      return Number.isFinite(number) ? number : fallback;
    },
    prepararItensConversao() {
      if (!Array.isArray(this.items)) return;
      this.items.forEach((item) => this.normalizarItemConversao(item));
    },
    normalizarItemConversao(i) {
      if (!i) return;

      const quantidade = this.toNumber(i.quantidade);
      const quantidadeConversao = this.toNumber(i.quantidade_conversao);

      if (!i.operacao_conversao) {
        const operacaoInicial =
          quantidade > 0 &&
          quantidadeConversao > 0 &&
          quantidadeConversao < quantidade
            ? this.divisao
            : this.multiplicar;
        this.$set(i, "operacao_conversao", operacaoInicial);
      }

      if (!this.toNumber(i.fator_conversao)) {
        let fatorInicial = 1;

        if (
          quantidade > 0 &&
          quantidadeConversao > 0 &&
          quantidadeConversao !== quantidade
        ) {
          fatorInicial =
            i.operacao_conversao == this.divisao
              ? quantidade / quantidadeConversao
              : quantidadeConversao / quantidade;
        }

        this.$set(i, "fator_conversao", fatorInicial);
      }

      if (!this.toNumber(i.quantidade_conversao)) {
        this.$set(i, "quantidade_conversao", this.toNumber(i.quantidade, 1));
      }

      if (
        !Object.prototype.hasOwnProperty.call(i, "custo_original_conversao")
      ) {
        this.$set(i, "custo_original_conversao", this.toNumber(i.custo));
      }
    },
    labelOperacaoConversao(i) {
      this.normalizarItemConversao(i);
      return i.operacao_conversao == this.divisao ? "Dividir" : "Multiplicar";
    },
    alternarOperacaoConversao(i) {
      this.normalizarItemConversao(i);
      i.operacao_conversao =
        i.operacao_conversao == this.divisao ? this.multiplicar : this.divisao;
      this.calcularConversaoPorFator(i);
    },
    onInputFatorConversao(i) {
      this.$nextTick(() => {
        if (this.toNumber(i.fator_conversao) > 0) {
          this.calcularConversaoPorFator(i);
        }
      });
    },
    onBlurFatorConversao(i) {
      this.normalizarItemConversao(i);
      if (this.toNumber(i.fator_conversao) <= 0) {
        i.fator_conversao = 1;
      }
      this.calcularConversaoPorFator(i);
    },
    calcularConversaoPorFator(i, emitChange = true) {
      this.normalizarItemConversao(i);

      const base = this.toNumber(i.quantidade);
      const fator = this.toNumber(i.fator_conversao, 1);

      if (i.operacao_conversao == this.divisao) {
        i.quantidade_conversao = fator ? base / fator : base;
      } else {
        i.quantidade_conversao = base * fator;
      }

      this.recalcularCustoConversao(i);

      if (emitChange) {
        this.$emit("onItemsChange", this.items);
      }
    },
    recalcularCustoConversao(i) {
      this.normalizarItemConversao(i);

      const custoOriginal = this.toNumber(i.custo_original_conversao);
      const quantidade = this.toNumber(i.quantidade);
      const quantidadeConversao = this.toNumber(i.quantidade_conversao);

      if (quantidade > 0 && quantidadeConversao > 0) {
        i.custo = (custoOriginal * quantidade) / quantidadeConversao;
      }
    },
    setConversao(i, index) {
      this.normalizarItemConversao(i);

      if (!i.unidade_medida) {
        i.quantidade_conversao = i.quantidade;
        i.operacao_conversao = this.multiplicar;
        i.fator_conversao = 1;
        this.recalcularCustoConversao(i);
        return;
      }

      const conversor = this.toNumber(i.unidade_medida.conversor);
      const tipoConversor = this.toNumber(i.unidade_medida.tipo_conversor);
      if (conversor > 0 && tipoConversor > 0) {
        i.fator_conversao = conversor;
        i.operacao_conversao = tipoConversor;
      }

      this.calcularConversaoPorFator(i, false);

      this.unidadeError = false;
      this.hasFilled = true;

      // aplicar para todos (apenas ao escolher no primeiro item)
      if (index === 0) {
        this.$swal
          .fire({
            icon: "warning",
            title: `Deseja aplicar "${i.unidade_medida.nome}" para todos os itens?`,
            showCancelButton: true,
            confirmButtonText: `Sim`,
            cancelButtonText: `Não`,
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              this.items = this.items.map((item) => {
                const novo = {
                  ...item,
                  unidade_medida: i.unidade_medida,
                  operacao_conversao: i.operacao_conversao,
                  fator_conversao: i.fator_conversao,
                };
                this.normalizarItemConversao(novo);
                this.calcularConversaoPorFator(novo, false);
                return novo;
              });
              this.$toast.success(
                `"${i.unidade_medida.nome}" aplicada para todos os itens!`
              );
              this.$emit("onItemsChange", this.items);
            }
          });
      }
    },
    onBlurConversao(i) {
      this.normalizarItemConversao(i);
      let v = this.toNumber(i.quantidade_conversao);
      if (!isFinite(v) || v <= 0) {
        v = this.toNumber(i.quantidade, 1);
      }
      i.quantidade_conversao = v;
      this.recalcularCustoConversao(i);
      this.$emit("onItemsChange", this.items);
    },
  },
  watch: {
    items: {
      immediate: true,
      handler() {
        this.prepararItensConversao();
      },
    },
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (oldValue === 3 && newValue === 4) {
          if (!this.items.every((element) => !!element.unidade_medida)) {
            this.$toast.error("Selecione uma unidade para prosseguir!");
            this.unidadeError = true;
            this.store.currentTab = oldValue;
          }
        }
      }
    },
  },
};
</script>

<style>
.compra-un-dropdown.vs__dropdown-menu {
  z-index: 1050;
  min-width: 0;
  max-height: 240px;
  max-height: min(240px, calc(100dvh - 16px));
  transition: none;
}

.card-titulo-itens .card-title {
  margin-bottom: 0 !important;
  font-weight: 700;
  font-size: 1.75rem;
  padding: 0.75rem;
}

.card-titulo-itens .card-body {
  padding: 0.45rem;
}

.card-titulo-itens {
  background-color: #fff;
  border: 0px;
  text-align: center;
  margin-bottom: 0px;
  padding: 0;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

.card-itens .card-body {
  padding: 0;
}

.table {
  border-bottom: solid 0px #dedede;
  margin-bottom: 0px;
}

.tableItensCompra {
  /* padding: 10px; */
  overflow-y: auto;
  max-height: calc(100vh - 297px);
  /* height: calc(100vh - 297px); */
  border: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.tableItensCompra th,
.tableItensCompra td {
  padding: 8px 16px;
}

.tableItensCompra .table tr th {
  border-bottom: 2px solid var(--color-primary);
}

.tableItensCompra th {
  position: sticky;
  top: 0;
  background: #fff;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 1px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 200px rgb(229 245 234 / 19%);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-secondary);
}

.card-total-venda {
  background: transparent;
  border: 0px;
  top: 30px;
}

.card-total-venda .card-body {
  padding: 0rem 1rem 0rem 1rem;
}

.card-total-left {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
  color: #fff;
  border-radius: 0px;
  border-bottom-left-radius: 20px !important;
  height: 90px;
  width: 101%;
  display: table;
  text-align: left;
}

.card-total-left .card-body {
  display: table-cell;
  vertical-align: middle;
}

.card-total-right {
  background-color: var(--color-secondary);
  border-color: var(--color-secondary);
  color: #fff;
  border-radius: 0px;
  align-items: flex-end;
  border-bottom-right-radius: 20px !important;
  height: 90px;
  width: 100%;
  display: table;
  text-align: center;
  text-align: right;
}

.card-total-right .card-body {
  display: table-cell;
  vertical-align: middle;
}

.card-total-right p,
.card-total-left p {
  margin-bottom: 0;
  font-size: 0.8rem;
}

.card-total-right h5,
.card-total-left h5 {
  font-size: 1.75rem !important;
  margin-bottom: 0;
}

.tableItensCompra tbody tr {
  border-top-width: 1.5px;
  /* border-top-style: dashed; */
  border-top-color: var(--color-primary);
}

blockquote {
  margin: 0 auto;
  position: relative;
  text-align: center;
  z-index: 1;
}

blockquote:after {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 29px;
  right: 0;
  bottom: -24px;
  left: 0;
  padding-top: 10px;
  background: linear-gradient(-45deg, transparent 70%, white 75%),
    linear-gradient(45deg, transparent 70%, white 75%);
  background-repeat: repeat-x;
  background-size: 25px 20px, 25px 20px;
  background-position: center;
}
</style>
